import type { SVGProps } from "react";

const SvgBtvSmallLogo = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="-30.8 114.2 573.6 282.9"
    fill="none"
    {...props}
  >
    <path
      fill="#E20020"
      d="M31.539 353.833c-9.35-.798-16.453-1.529-20.539-2.113V159.322c3.807-.558 10.206-1.162 22.107-2.113 10.545-.804 23.37-1.209 38.12-1.209 22.147 0 38.287 3.954 49.324 12.08a38.86 38.86 0 0 1 16.565 33.768 43.1 43.1 0 0 1-6.983 25.855h.179a43.4 43.4 0 0 1-13.954 13.469 53.6 53.6 0 0 1-10.419 4.531 53.5 53.5 0 0 1 12.586 3.569 41.4 41.4 0 0 1 16.744 13.11 43.06 43.06 0 0 1 8.253 28.333 59.52 59.52 0 0 1-19.695 47.297c-13.057 11.495-31.815 17.329-55.796 17.329-12.565 0-24.472-.492-36.492-1.508m18.127-31.41a73 73 0 0 0 8.252 1.807 81 81 0 0 0 13.648 1.157h.745a32.1 32.1 0 0 0 23.608-7.921 32.57 32.57 0 0 0 7.888-23.788l-.12.665a27.45 27.45 0 0 0-8.399-21.835 37.77 37.77 0 0 0-25.203-7.309h-20.42zm19.389-134.528c-6.067 0-10.253.132-13.19.418-1.429.14-2.618.293-3.575.419a23 23 0 0 1-2.445.252v47.782l6.445.419h11.084c.89.073 1.794.106 2.657.106a33.22 33.22 0 0 0 20.32-6.99 24.93 24.93 0 0 0 7.409-19.21v-.119a20.89 20.89 0 0 0-7.469-17.031 32.5 32.5 0 0 0-19.03-6.113c-.711-.007-1.469.02-2.206.067m326.427 163.818-71.065-192.391h44.068l45.589 125.645 47.118-125.645H501l-74.142 192.391zm-177.965 0V194.965h-62.393v-35.643h164.19v35.643h-61.988v156.748z"
    />
  </svg>
);
export default SvgBtvSmallLogo;
